export function devlog(cat, ...params) {
    var cats = ["route", "vals", "event", "basket"];
    cats = [];
    if (import.meta.env.MODE == "development" && cats.includes(cat))
        console.log("[" + cat + "] ", ...params);
}
